import { z } from 'zod';

// Slack notifications for the organization's CS team, purpose-scoped
// (mirrors the SLACK_CS_*_REFERRALS_CHANNEL env taxonomy):
// - customerSupportReferralsChannel: referral lifecycle events (new referral, reminders,
//   cancellations, referral email failures)
// - customerSupportCasesChannel: case lifecycle events (discharged, end of support,
//   appointment alerts)
// - customerSupportPatientConsentCallsChannel: referrals whose patient consent
//   is still pending (consent.patient.referral) — the CS team must phone the
//   member and record what they said before the referral can proceed, so this
//   action-required feed is separately routable from the general referral events
// An empty string means "no channel" (no notifications for that purpose).
// A present doc fully defines the group: all fields are required.
export const SlackNotificationsSettingsSchema = z.strictObject({
  appointmentAlerts: z.boolean(),
  customerSupportReferralsChannel: z.string().max(80),
  customerSupportCasesChannel: z.string().max(80),
  customerSupportPatientConsentCallsChannel: z.string().max(80),
});

export type SlackNotificationsSettings = z.infer<
  typeof SlackNotificationsSettingsSchema
>;
